"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcSidebarModalDialog = void 0;
var react_1 = __importDefault(require("react"));
var AcSidebarModalDialog = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: 'aperza-app', style: {
            height: '100%',
            width: 375,
            position: 'absolute',
            right: 0,
            backgroundColor: '#ffffff',
        } }, children));
};
exports.AcSidebarModalDialog = AcSidebarModalDialog;
exports.AcSidebarModalDialog.displayName = 'AcSidebarModalDialog';
//# sourceMappingURL=AcSidebarModalDialog.js.map